import React, { RefObject, useImperativeHandle, useRef, PropsWithChildren } from 'react'
import { createStyles, withStyles, } from '@mui/styles'
import { defaultColors, muiOptions, MuiProps } from '../../../infrastructure/materialUiThemeProvider'

type FieldHintEffectProps = {
    fieldHintEffectRef: RefObject<FieldHintEffectRef>
}

const ANIMATION_DELAY = 350

export function _FieldHintEffect({ classes, fieldHintEffectRef, children }:
    MuiProps & PropsWithChildren<FieldHintEffectProps>) {
    const ref = useRef<HTMLDivElement>(null)

    useImperativeHandle(fieldHintEffectRef, () => ({
        animate: async () => {
            if (ref) {
                ref.current!.classList.remove(classes.animate)
                ref.current!.classList.add(classes.animate)
                setTimeout(() => ref.current!.classList.remove(classes.animate), ANIMATION_DELAY)
            }
        }
    }))

    return (<div ref={ref} className={classes.container}>{children}</div>)
}

const styles = _ => createStyles({
    container: {
        boxShadow: '0 0 0 0 transparent',
        transition: `box-shadow ${ANIMATION_DELAY}ms, transform ${ANIMATION_DELAY}ms ease-in-out`,
        transform: "translateY(0)"
    },
    animate: {

        transition: `box-shadow ${ANIMATION_DELAY}ms, transform ${ANIMATION_DELAY}ms ease-in-out`,
        boxShadow: `0 0 15px 7px ${defaultColors.grey.light.color}`,
        transform: "translateY(-8px)"
    },
})

export let FieldHintEffect = withStyles(styles, muiOptions)(_FieldHintEffect)

export type FieldHintEffectRef = { animate: () => void }